import React, { useState } from 'react';
import FormError from '../partials/FormError';
import { Skeleton } from '@/components/core';
import __ from '../../helpers/translation';
export var SublocationConfirmModal = function (_a) {
    var _b;
    var onConfirm = _a.onConfirm, sublocation = _a.sublocation;
    var _c = useState(''), errors = _c[0], setErrors = _c[1];
    var confirm = function (e) {
        //@ts-ignore
        window.$('#confirmSublocation').modal('hide');
        return onConfirm(e);
    };
    var cancel = function () {
        //@ts-ignore
        window.$('#confirmSublocation').modal('hide');
        //@ts-ignore
        window.$('#sublocationFailedConfirmFeedback').modal('show');
    };
    if (!sublocation)
        return null;
    return (React.createElement("div", { id: "confirmSublocation", className: "modal fade", tabIndex: -1, role: "dialog", "aria-labelledby": "confirmsublocation", "aria-hidden": "true" },
        React.createElement("div", { className: "modal-dialog modal-lg modal-dialog-centered", role: "document" },
            React.createElement("div", { className: "modal-content p-3 p-sm-5" },
                React.createElement("div", { className: "modal-header" },
                    React.createElement("h1", { className: "modal-title fw-600" }, __('app.inspections.confirm_sublocation_title')),
                    React.createElement("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close" },
                        React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
                React.createElement("div", { className: "modal-body" },
                    errors && (React.createElement(FormError, null, errors)),
                    React.createElement("p", null, __('app.inspections.confirm_sublocation_message', { sublocation: (_b = sublocation.name) !== null && _b !== void 0 ? _b : '' })),
                    sublocation.image_url ? (React.createElement("img", { className: "img-fluid mt-2", src: "data:image/png;base64,".concat(sublocation.image_url), alt: __('app.inspections.title_sublocation') })) : (React.createElement(Skeleton, { className: 'tw-w-full tw-h-80' })),
                    React.createElement("button", { onClick: confirm, className: "btn-success btn btn-block w-100 mt-5" }, __('app.inspections.confirm_positive')),
                    React.createElement("button", { onClick: cancel, className: "btn btn-black d-block w-100 mt-2" }, __('app.inspections.confirm_negative')))))));
};
export default SublocationConfirmModal;
